import React, { useEffect, useState } from "react";
import { Col, Row, Button, Alert, ToggleButton, ToggleButtonGroup, Form } from "react-bootstrap";
import { useStoreState, useStoreActions } from 'easy-peasy';
import { Link } from "react-router-dom";
import useSearchWithParams from "../../hooks/useSearchWithParams.jsx";
import useCustomGetStoreState from "../../hooks/useCustomGetStoreState.jsx";
import Loader from "../../components/widgets/Loader.jsx";
import ActivityTableComponent from "../../components/activity/ActivityTableComponent.jsx";
import HelperMetiers360 from "../../services/HelpersMetiers360.js";
import AuthorizationChecker from "../../services/AuthorizationChecker.js";
import ActivityBoardComponent from "../../components/activity/ActivityBoardComponent.jsx";
import { useModal } from '../../hooks/useModal.jsx';
import { useToast } from "../../hooks/useToast.jsx";

import './ActivityPage.scss';


const ActivitiesContentPage = ({ clientById, isLoading }) => {

    const { editClientActivityBlacklist } = useStoreActions(actions => actions.clients);
    const { gradualFetchActivitiesProps } = useStoreActions(actions => actions.activity);

    const viewStylePreference = useStoreState(state => state.preferences.activityListStyle);
    const setViewStylePreference = useStoreActions(actions => actions.preferences.setActivityListStyle);

    const activityBoardSortType = useStoreState(state => state.preferences.activityBoardSortType);
    const setActivityBoardSortType = useStoreActions(actions => actions.preferences.setActivityBoardSortType);

    const { allActivity, isFetchingAllActivity } = useCustomGetStoreState('activity');
    const [filteredActivities, setFilteredActivities] = useState(allActivity);

    const activitySlugs = useStoreState(state => state.actionSlugs.actionSlugsDispatcher("activity"));

    const { modalComponent, setModalShow, modalData, setModalData } = useModal();
    const toast = useToast();

    const [viewStyle, setViewStyle] = useState(viewStylePreference ?? 'cards');

    const handleChange = (val) => {
        setViewStyle(val);
        setViewStylePreference(val);
    }

    const { searchInput, search } = useSearchWithParams({
        placeholder:
            'Rechercher par titre', delay: 400
    });

    useEffect(() => {
        if (!allActivity || allActivity.length === 0) return;
        gradualFetchActivitiesProps();
    }, [allActivity]);

    useEffect(() => {
        allActivity?.length &&
            setFilteredActivities(
                [...allActivity
                    .filter((activity) => HelperMetiers360.isSearchInText(search, activity.title))]
            )
    }, [search, allActivity]);

    const createBlacklistModal = (activity) => {
        setModalData({
            ...modalData,
            header: <>{activity?.isBlackListed ? "Ajouter" : "Retirer"} l'activité</>,
            content: <>
                {activity?.isBlackListed ?
                    <Alert variant="info">
                        Cette action rendra cette activité visible par vos utilisateur⋅rices dans leur webapp
                    </Alert> :
                    <Alert variant="info">
                        Cette activité ne sera plus visible par vos utilisateur⋅rices dans leur webapp.
                    </Alert>}
                <Alert variant="warning">
                    Cette modification peut prendre jusqu'à 24h avant d'être visible dans votre webapp.
                </Alert>
                {clientById?.clientChildren?.length > 0 && <Form.Check
                    name="applyToAllNetwork"
                    id='applyToAllNetwork'
                    type='checkbox'
                    label="Appliquer aussi ce réglage à l'ensemble de mon réseau"
                    defaultChecked={false} />}
            </>,
            cancelButton: 'Annuler',
            onValidate:
                () => {
                    editClientActivityBlacklist(
                        {
                            activityUuid: activity.uniqueId,
                            blacklisted: !activity.isBlackListed,
                            applyToAllNetwork: document.getElementById('applyToAllNetwork')?.checked
                        }
                    ).then(() => {
                        toast.open({ message: "Accès à l'activité modifié", variant: "success" });
                        setModalShow(false)
                    })
                }
        });
        setModalShow(true);
    }

    const viewStyleType = [
        { value: 'cards', label: <i className="fas fa-address-card"></i>, view: <ActivityBoardComponent sortTypePreferenceTuple={[activityBoardSortType, setActivityBoardSortType]} activities={filteredActivities} createBlacklistModal={createBlacklistModal} {...activitySlugs} /> },
        { value: 'table', label: <i className="fas fa-table"></i>, view: <ActivityTableComponent activities={filteredActivities} createBlacklistModal={createBlacklistModal} {...activitySlugs} /> },
    ];

    const checkViewStyle = viewStyleType.map(
        type => <ToggleButton value={type.value} key={type.value} id={type.value} checked={type.value === viewStyle}>{type.label}</ToggleButton>
    );

    return isLoading
        ? <Loader />
        : <>
            <Row className="item-page">
                <Col>
                    {searchInput}
                </Col>
                <Col className="col-auto">
                    <ToggleButtonGroup type="radio" name="option-view-romes" value={viewStyle} onChange={handleChange}>
                        {checkViewStyle}
                    </ToggleButtonGroup>
                </Col>
                {AuthorizationChecker.hasCreateRights('activity')
                    && <Col className="col-auto">
                        <Button variant="success" as={Link} to={activitySlugs.create}><i className="fas fa-plus"></i> &nbsp;Nouveau</Button>
                    </Col>}
            </Row>
            <Row>
                {(isFetchingAllActivity || !allActivity) ? <Loader />
                    : (filteredActivities?.length > 0 ?
                        viewStyleType.filter(type => type.value === viewStyle)[0].view
                        : <Alert variant="warning">Aucune activité à afficher</Alert>)
                }
            </Row>
            {modalComponent}
        </>
}

export default ActivitiesContentPage;